/**
 * Re-export from @kit/logger for backward compatibility
 * @deprecated Import directly from @kit/logger instead
 */
export { getLogger, withLogger } from '@kit/logger';
export type { Logger } from '@kit/logger';
